import { render, staticRenderFns } from "./cabinet-sideblock-menu.vue?vue&type=template&id=482eb03c&scoped=true"
import script from "./cabinet-sideblock-menu.vue?vue&type=script&lang=js"
export * from "./cabinet-sideblock-menu.vue?vue&type=script&lang=js"
import style0 from "./cabinet-sideblock-menu.vue?vue&type=style&index=0&id=482eb03c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482eb03c",
  null
  
)

export default component.exports